// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgLightbulb = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 8c0-2.183 1.505-4.5 4.5-4.5s4.5 2.317 4.5 4.5c0 1.765-.644 2.717-1.301 3.429a14.77 14.77 0 0 1-.51.517l-.016.016c-.172.17-.356.351-.518.535-.32.366-.655.853-.655 1.503h-3c0-.65-.334-1.137-.655-1.503a10.365 10.365 0 0 0-.518-.535l-.017-.016c-.172-.17-.341-.336-.509-.517C6.144 10.717 5.5 9.765 5.5 8Zm3 7.5v.75c0 .138.111.25.25.25h2.5a.25.25 0 0 0 .25-.25v-.75h-3ZM10 2C5.995 2 4 5.183 4 8c0 2.235.856 3.533 1.699 4.446.193.21.385.398.553.563l.023.023c.18.176.323.319.443.455.241.275.282.413.282.513v2.25c0 .968.784 1.75 1.75 1.75h2.5A1.75 1.75 0 0 0 13 16.25V14c0-.1.04-.238.282-.513a9.04 9.04 0 0 1 .443-.455l.023-.023c.168-.165.36-.354.553-.563C15.144 11.533 16 10.235 16 8c0-2.817-1.995-6-6-6Z"
    />
  </svg>
)

export default SvgLightbulb
